import { BaseEntity } from '../../../models';
import { CidadeSubRegiaoBairro } from '../bairro';

export class CidadeSubRegiao implements BaseEntity {
    readonly id: number;
    nome: string;
    idCidade: number;
    classificacao: number;
    bairros: CidadeSubRegiaoBairro[];

    constructor() {
        this.bairros = [];
    }
}
